import { NotificationController } from 'core-components/library/popup'
import { Logic, Operator } from 'core-components/types'
import { proxy } from 'src/core/classes/helpers/UrlHelper'
import { Rest } from 'src/core/classes/http'
import { IRemoveFileData } from 'src/core/classes/models/IFileData'
import { CrudHelper } from 'src/core/types/helpers/CrudHelper'
import Logger from 'src/core/utils/Logger'

export const deleteFile = async ({ isNoteRemoved = true, ...fileData}: IRemoveFileData) => {
  if (!fileData.fileName) {
    return Promise.resolve()
  }
  let fileUID = fileData.UID
  const source = new CrudHelper(fileData.formId, fileData.formCode)
  if (!fileData.UID) {
    const fileInfo = await source.readFromTo({
      logic: Logic.AND,
      filters: [{ field: 'EntryId', operator: Operator.EQUAL, value: fileData.entryId }],
    })
    fileUID = fileInfo.Data[0].UID
  }

  if (!fileUID) {
    Logger.error(`File ${fileData.entryId} not found or UID does not exist`)
    NotificationController.showError({ message: 'File not found' })
    return Promise.resolve()
  }

  const url = proxy(
    `/form/${fileData.formId}/attachments/v2/${fileUID}/${fileData.fieldName}/handler`
  )

  const data = new FormData()
  data.append('Attachment', 'Attachment')
  data.append(fileData.fieldName, fileData.fileName)

  const removeFilePromise = Rest.delete({
    url,
    payload: data,
  })

  const attachmentData = {}
  if (fileData.entryId) {
    Object.assign(attachmentData, { EntryId: fileData.entryId })
  }
  if (fileData.UID) {
    Object.assign(attachmentData, { UID: fileData.UID })
  }

  const removeFilePromises = [removeFilePromise]

  if (isNoteRemoved) {
    const removeNotePromise = source.delete([attachmentData])
    removeFilePromises.push(removeNotePromise)
  }

  await Promise.all(removeFilePromises)

  if (fileData.source) {
    fileData.source.deleteItem({ models: attachmentData })
  }
}
